/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {useSelector} from 'react-redux'
import {isEmpty, isLoaded, useFirestoreConnect} from 'react-redux-firebase'
import {errors} from '../../utils/config'

const CustomerDataReady = ({children, uid}) => {
  useFirestoreConnect([
    {collection: 'users', doc: uid, storeAs: 'user'},
    {collection: 'course', doc: 'sotsc', storeAs: 'course'},
    {collection: 'enrollments', where: [['parentId', '==', uid]]},
  ])
  const user = useSelector(state => state.firestore?.data?.user)
  const enrollments = useSelector(state => state.firestore?.data?.enrollments)

  // Customer payload is being loaded from Firestore.
  if (!isLoaded(user)) return null

  // There's no customer license available on Firestore for this user.
  if (isLoaded(user, enrollments) && isEmpty(enrollments))
    throw new Error(errors.noCustomerData.message)
  // The current user qualifies as a customer and is authorized to continue.
  return children
}

export default CustomerDataReady
